import { Alert, Button } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import { Screen, ScreenContent } from "components/Screen";
import { useJettonAddress } from "hooks/useJettonAddress";
import useNotification from "hooks/useNotification";
import { Token } from "pages/jetton/dataRow/token";
import { StyledContainer } from "pages/jetton/styled";
import { Wallet } from "pages/jetton/wallet";
import { useEffect } from "react";
import useJettonStore from "store/jetton-store/useJettonStore";
import FaultyDeploy from "./FaultyDeploy";
import { useNetwork } from "lib/hooks/useNetwork";

export const Jetton = () => {
  const { getJettonDetails, jettonError, jettonLoading } = useJettonStore();
  const { isAddressEmpty, jettonAddress } = useJettonAddress();
  const { showNotification } = useNotification();
  const { network } = useNetwork();

  useEffect(() => {
    if (jettonAddress) {
      getJettonDetails();
    }
  }, [jettonAddress, getJettonDetails, network]);

  useEffect(() => {
    !isAddressEmpty && !jettonAddress && showNotification("Invalid jetton address", "error");
  }, [isAddressEmpty, jettonAddress, showNotification]);

  return (
    <Screen>
      <FaultyDeploy />
      <ScreenContent>
        {jettonError && (
          <Alert
            severity="error"
            sx={{ mb: 2 }}
            action={
              <Button
                color="inherit"
                size="small"
                startIcon={<RefreshIcon />}
                disabled={jettonLoading}
                onClick={() => getJettonDetails()}
              >
                重试
              </Button>
            }
          >
            {jettonError}
          </Alert>
        )}
        <StyledContainer>
          <Token />
          <Wallet />
        </StyledContainer>
      </ScreenContent>
    </Screen>
  );
};
